(() => {
  if (customElements.get('list-carousel')) {
    return;
  }

  class ListCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        drag: 'free',
        perPage: 2,
        padding: { right: 123 },
        gap: 8,
        arrows: true,
        pagination: false,
        mediaQuery: 'max',
        breakpoints: {
          1300: {
            padding: { right: 60 }
          },
          1200: {
            perPage: 1
          },
          767: {
            perPage: 1,
            padding: { right: 80 }
          }
        }
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.slider = new Splide(this,this.options).mount();
    }
  }

  customElements.define('list-carousel', ListCarousel);
})();
